import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import nailtibiarender from "./Img/nailtibiarender.webp";
import Goneo from "./Img/goneo.webp";
import better from "./Img/Better3.webp";
import nailtsm from "./Img/monail.png";
import Goneosm from "./Img/goneo.jpg";
import bettersm from "./Img/mobetter.png";


const Data = [
  {
    items: [
      {
        image: better,
        title: "Better",
        subtitle: "Gamified Rehabilation Device. ",
        buttonText: "Know more",
        route: "/Physio",
        state: "better",
      },
      {
        image: Goneo,
        title: "GoNeo",
        subtitle: "Digital Goniometer For Pro Physios",
        buttonText: "Know more",
        route: "/Physio",
        state: "goNeo",
      },
      {
        image: nailtibiarender,
        title: "IM Bone Lengthening Nail",
        subtitle: "Complete internal Lengthening From 9MM Diameter And Above",
        buttonText: "Know more",
      },
    ],
    lists: [
      {
        image: bettersm,
        title: "Better",
        subtitle: "Gamified Rehabilation Device. ",
        buttonText: "Know more",
        route: "/Physio",
        state: "better",
      },
      {
        image: Goneosm,
        title: "GoNeo",
        subtitle: "Digital Goniometer For Pro Physios",
        buttonText: "Know more",
        route: "/Physio",
        state: "goNeo",
      },
      {
        image: nailtsm,
        title: "IM Bone Lengthening Nail",
        subtitle: "Complete internal Lengthening From 9mm Diameter And Above",
        buttonText: "Know more",
      },
    ],
  },
];

export function BgHome() {
  const navigate = useNavigate();
  const location = useLocation();

  // State to track whether the screen is large (>= 780px)
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
    window.matchMedia("(min-width: 1280px)").matches
  );

  // Hook to listen for window resize and update the screen size state
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const handleChange = (e) => setIsLargeScreen(e.matches);
    mediaQuery.addEventListener("change", handleChange);

    // Clean up the event listener on unmount
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const handleButtonClick = (route, state) => {
    navigate(route, { state });
  };
   useEffect(() => {
       window.scrollTo(0, 0); // Scroll to top of the page
     }, [location.pathname]);

  return (
    <div className="d-flex position-relative flex-column m-0 p-0 ">
      {isLargeScreen &&
        Data[0].items.slice(0, 3).map((item, index) => (
          <div
            key={index}
            className="d-flex position-relative flex-row m-0 p-0 uh-130"
            style={{ overflow: "hidden" }}
          >
            {/* Image */}
            <div
              className="uh-130 m-0 p-0 w-100"
              style={{
                backgroundImage: `url(${item.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
            <div className="position-absolute d-flex flex-column upx-20 bottom-0 uh-130 upy-20 uw-130 justify-content-end">
              {/* Content inside the right-side div */}
              <p className="m-0 p-0 ufs-8 fw-bold text-gray">{item.title}</p>
              <p className="m-0 p-0 ufs-4 fw-bold text-gray">{item.subtitle}</p>
              <div className="m-0 d-flex upt-2 text-center uh-50">
                <button
                  className="ufs-6 uw-60 uh-12 text-center text-gray-light border-0 fw-bold bg-dark-blue br-10"
                  type="button"
                  onClick={() => handleButtonClick(item.route, item.state)}
                >
                  {item.buttonText}
                </button>
              </div>
            </div>
          </div>
        ))}

      {!isLargeScreen &&
        Data[0].lists.slice(0, 3).map((list, index) => (
          <div
            key={index}
            className="d-flex position-relative flex-column m-0 p-0"
            style={{ overflow: "hidden" }}
          >
            {/* Image */}
            <div
              className=" m-0 p-0 uw-320"
              style={{
                backgroundImage: `url(${list.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: '85vh'
              }}
            ></div>
            <div className="position-absolute upx-20 uh-160 bottom-0 upy-20 w-75">
              {/* Content inside the right-side div */}
              <p className="m-0 p-0 ufs-14 fw-bold text-gray">{list.title}</p>
              <p className="m-0 p-0 ufs-12 fw-bold text-gray">{list.subtitle}</p>
              <div className="m-0 d-flex upt-2 text-center ">
                <button
                  className="ufs-14 up-5 upx-8 text-center text-gray-light border-0 fw-bold bg-dark-blue br-20"
                  type="button"
                  onClick={() => handleButtonClick(list.route, list.state)}
                >
                  {list.buttonText}
                </button>
              </div>
            </div>
          </div>
        ))}

      {/* Chatbot */}
      
    </div>
  );
}
